import type { CountryCode } from 'svelte-tel-input/types';
import type { SelectOption } from './types';

export const REGIONS: SelectOption[] = [
  { key: 'United States', value: 'United States' },
  { key: 'United Kingdom', value: 'United Kingdom' },
  { key: 'Australia', value: 'Australia' },
  { key: 'Singapore', value: 'Singapore' },
  { key: 'Hong Kong', value: 'Hong Kong' },
  { key: 'Dubai', value: 'Dubai' },
  { key: 'Netherlands', value: 'Netherlands' },
];

export function mapCountryNameToCode(countryName: string): CountryCode | null {
  const countryMap: Record<string, CountryCode> = {
    'United States': 'US',
    'United Kingdom': 'GB',
    Australia: 'AU',
    Singapore: 'SG',
    'Hong Kong': 'HK',
    Dubai: 'AE',
    Netherlands: 'NL',
  };

  return countryMap[countryName] || null;
}

export function generateEnquiryId(): string {
  return crypto.randomUUID();
}